import FormProps from "./FormProps";
import styles from "./Form.module.scss";

import React, { FunctionComponent } from "react";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import combineClasses from "helpers/combine-classes";
import { useSelector } from "react-redux";

const Form: FunctionComponent<FormProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);

    const settings = useSelector(state => state.settings.content);

    return (
        <section className={combineClasses(styles.wrapper, ...wrapperClasses)} style={wrapperStyles}>
            <div className={styles.container}>
                <div className={styles.content} rekom-inline-form="true" form-id={props.content.identifier} venue-id={settings?.venueId}></div>
            </div>
        </section>
    );
};

export default Form;